import type { BigNumber } from '@ethersproject/bignumber';
import formatBigNumber from '@utils/format/formatBigNumber';

export default function formatAVAX(dps: BigNumber) {
  return formatBigNumber(dps, { divide: 18, precision: 5 });
}
